import styled from 'styled-components';

import { device } from '@/styles/helpers';

export const ScPaymentsText = styled.div`
  max-width: 51%;
  margin: 0 auto;
  text-align: center;
  margin-bottom: 64px;
  p,
  ul,
  ol {
    color: white !important;
  }
  @media (${device.mobile}) {
    max-width: 100%;
    margin-top: 32px;
  }
`;

export const ScPageTitle = styled.h1`
  font-weight: 700;
  font-size: 32px;
  line-height: 1.25;
  letter-spacing: 0.03em;
  text-transform: uppercase;
  @media (${device.mobile}) {
    font-size: 28px;
    line-height: 1.29;
    text-align: center;
  }
`;

export const ScPaymentMethodsCategory = styled.div`
  & > h2 {
    margin-top: 64px;
    font-weight: 700;
    font-size: 22px;
    line-height: 1.27;
    letter-spacing: 0.02em;
    text-transform: uppercase;
    margin-bottom: 32px;
    @media (${device.mobile}) {
      margin-top: 0;
      font-size: 20px;
      line-height: 1.3;
      text-align: center;
      letter-spacing: 0.02em;
      text-transform: uppercase;
      margin-bottom: 16px;
    }
  }
  @media (${device.mobile}) {
    margin-top: 28px;
  }
`;

export const ScPaymentsTable = styled.div`
  display: flex;
  flex-direction: column;
`;

export const ScPaymentsTableRow = styled.div<{ headerMode?: boolean }>`
  display: flex;
  flex-direction: row;
  align-items: center;
  min-height: ${({ headerMode }) => (headerMode ? 'auto' : 400)};
  background-color: ${({ theme, headerMode }) =>
    headerMode ? 'none' : theme.whiteColor};
  color: ${({ theme }) => theme.blackColor};
  border-radius: 8px;
  font-size: 16px;
  line-height: 24px;
  margin-bottom: 8px;
  display: grid;

  font-weight: ${({ headerMode }) => (headerMode ? 700 : 400)};
  color: ${({ theme, headerMode }) =>
    headerMode ? theme.whiteColor : theme.blackColor};
  font-size: 16px;
  line-height: 1.5;

  grid-template-columns: 18.75% 12.5% 12.5% 18.75% 18.75% 18.75%;

  .btn {
    display: flex;
    justify-content: center;
    align-items: center;
  }

  .method-img_container {
    display: flex;
    justify-content: center;
  }

  & > div {
    padding: ${({ headerMode }) => (headerMode ? '0 8px 8px' : '8px')};
  }
`;

export const ScPaymentsGrid = styled.div`
  display: grid;
  grid-template-columns: repeat(1, 1fr);
  grid-column-gap: 16px;
  grid-row-gap: 8px;
  @media (${device.mobileS}) {
    grid-template-columns: repeat(1, 1fr);
  }
`;

interface ScPaymentsTabsItemProps {
  isContentVisible: boolean;
}

export const ScPaymentsTabsItem = styled.div<ScPaymentsTabsItemProps>`
  width: 100%;
  background-color: ${({ theme }) => theme.whiteColor};
  color: ${({ theme }) => theme.blackColor};
  border-radius: 16px;
  display: flex;
  flex-direction: column;
  align-items: center;

  .el {
    display: flex;
    align-items: center;
    width: 100%;
  }
  .title {
    width: 37.5%;
    height: 100%;
    font-weight: 700;
    &__img {
      margin: auto;
    }
  }
  .arrow {
    transition: 0.3s;
    transform: ${({ isContentVisible }) =>
      isContentVisible ? 'rotate(-90deg)' : 'rotate(90deg)'};
    display: flex;
    min-width: 24px;
    justify-content: center;
    align-items: center;
    i {
      color: ${({ theme }) => theme.color2};
    }
  }
  .value {
    width: 62.5%;
    padding-left: 10px;
    color: ${({ theme }) => theme.blackColor};
    * {
      color: ${({ theme }) => theme.blackColor};
    }
    p {
      margin-top: 0;
    }
  }
  .header {
    height: 64px;
    display: flex;
    width: 100%;
    padding: 0 16px;

    .title {
      display: flex;
    }
    .value {
    }
  }
  .content {
    overflow: hidden;
    max-height: ${({ isContentVisible }) => (isContentVisible ? '500px' : 0)};
    opacity: ${({ isContentVisible }) => (isContentVisible ? 1 : 0)};
    width: 100%;
    margin-top: ${({ isContentVisible }) => (isContentVisible ? '16px' : 0)};
    padding: ${({ isContentVisible }) =>
      isContentVisible ? '0px 16px 16px' : 0};

    transition: max-height
      ${({ isContentVisible }) => (isContentVisible ? '0.4s' : '0.1s')} ease;
    button {
      width: 100%;
    }
    .el {
      border-top: 1px solid #f2f2f4;
      padding-top: 12px;
      padding-bottom: 12px;
      word-break: break-all;

      &:last-of-type {
        padding-bottom: 16px;
      }
    }
  }
`;
